import { CalendarViewEventRouteParams } from '../schema/CalendarViewEventRouteParams';
import { getReadingPaneStore } from '../Store';

/**
 * Selector to get the calendarViewDetails from the store
 */
export const getCalendarViewEventRouteParams = (): CalendarViewEventRouteParams =>
    getReadingPaneStore().calendarViewEventRouteParams || { eventId: null };
